// extracted by mini-css-extract-plugin
export default {"badge":"TierBadge_badge__Z7a6B","tier_A":"TierBadge_tier_A__LX5hI","tier_B":"TierBadge_tier_B__k2Bcd","tier_C":"TierBadge_tier_C__b+yDj"};